module.exports = __webpack_public_path__ + "static/img/3.16e4558.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail/cs/3.jpg
// module id = T/BC
// module chunks = 1